<template>
	<div class="vue-form">
    <b-jumbotron>
		<p v-html="intro.subtitle" class="lead" style="margin: 0; font-size: 2em; font-weight: 600;"></p>
		<p v-html="intro.desc" class="lead" style="margin:0; text-align: left; font-size: 1.2em; font-weight: normal;"></p>
	</b-jumbotron>

		<form
			ref="form"
			:action="results.action"
			method="post"
			@submit="onSubmit"
			name="vfm"
		>
			<input type="hidden" name="post" :value="results.post" />

			<div class="email_field_group">
				<input
					type="hidden"
					:name="'email_1_from_name'"
					:value="results.emails[0].from_name"
				/>
				<input
					type="hidden"
					:name="'email_1_from'"
					:value="results.emails[0].from"
				/>
				<input
					type="hidden"
					:name="'email_1_to'"
					:value="results.emails[0].to"
				/>
				<input
					type="hidden"
					:name="'email_1_subject'"
					:value="results.emails[0].subject"
				/>
				<input type="hidden" :name="'email_1_body'" :value="email_1_body" />
			</div>

			<div class="email_field_group">
				<input
					type="hidden"
					:name="'email_2_from_name'"
					:value="results.emails[1].from_name"
				/>
				<input
					type="hidden"
					:name="'email_2_from'"
					:value="results.emails[1].from"
				/>
				<input
					type="hidden"
					:name="'email_2_to'"
					:value="items.vfm_email.data"
				/>
				<input
					type="hidden"
					:name="'email_2_subject'"
					:value="results.emails[1].subject"
				/>
				<input type="hidden" :name="'email_2_body'" :value="email_2_body" />
			</div>

			<div class="csv_field_group" v-for="(csv, f_index) in this.csv_files">
				<input
					type="hidden"
					:name="'csv_' + (f_index + 1).toString() + '_file'"
					:value="'/upload/results/' + csv.path + csv.file"
				/>
				<input
					v-for="(item, key, i_index) in items"
					:key="key"
					:name="csvEnum(item.name, f_index, i_index)"
					type="hidden"
					:value="getCSVValue(csv.omit, key)"
				/>
				<input name="csv_1_field_18" type="hidden" value="Stamp" />
			</div>
			
			<input type="hidden" name="ToggleCredits" :value="this.toggleCredits" />
			<input type="hidden" name="TuitionCategory" :value="this.tuitionCategory" />
			<input type="hidden" name="TuitionOnCapus" :value="this.tuitionRateOn.toFixed(2)" />
			<input type="hidden" name="CampusCredits" :value="this.onCampusCredits" />
			<input type="hidden" name="CampusTuition" :value="this.onCampusTuition.toFixed(2)" />
			<input type="hidden" name="OnlineTuition" :value="this.onlineTuition.toFixed(2)" />
			<input type="hidden" name="GeneralActivityFee" :value="this.activityFee.toFixed(2)" />
			<input type="hidden" name="AtmEngScienceFee" :value="this.aesFee.toFixed(2)" />
			<input type="hidden" name="BiologyFee" :value="this.bioFee.toFixed(2)" />
			<input type="hidden" name="ChemistryFee" :value="this.chemFee.toFixed(2)" />
			<input type="hidden" name="GeologyFee" :value="this.geoFee.toFixed(2)" />
			<input type="hidden" name="PhysicsFee" :value="this.phyFee.toFixed(2)" />
			<input type="hidden" name="ComputerSciFee" :value="this.csiFee.toFixed(2)" />
			<input type="hidden" name="EngineeringFee" :value="this.engFee.toFixed(2)" />
			<input type="hidden" name="MathFee" :value="this.mathFee.toFixed(2)" />
			<input type="hidden" name="MusicFee" :value="this.musFee.toFixed(2)" />
			<input type="hidden" name="EstimateTotal" :value="this.totEstimate.toFixed(2)" />
			<input type="hidden" name="SendFirstName" :value="this.firstName" />
			<input type="hidden" name="SendLastName" :value="this.lastName" />
			<input type="hidden" name="SendToEmail" :value="this.emailAddress" />
			<input type="hidden" name="Stamp" :value="results.stamp" />
			<input type="hidden" name="confirm" :value="results.confirm" />
			<input type="hidden" name="confirm_template" :value="confirm_template" />
			<div class="miners">
				<input class="miners" name="miners" value />
			</div>

			<b-modal v-model="meta.closed"></b-modal>

			<div class="vfm_item" v-for="(item, key) in items">
				<div v-if="item.section_header && item.show">
					<p style="color: #071d49; font-size: 1.2em;">{{ item.section_header }}</p>
				</div>
				<span v-if="item.type === 'nodata'">
					<b-card
						v-if="item.style && item.style === 'card'"
						border-variant="secondary"
						bg-variant="light"
						:header="item.title"
						header-text-variant="white"
						header-bg-variant="secondary"
					>
						<p class="card-text">{{ item.label }}</p>
					</b-card>
					<div v-else-if="item.style && item.style === 'html'">
						<span v-html="item.label" style="font-size: .8rem"></span>
					</div>
					<h4 v-else>
						<hr v-if="!item.first" />
						<span v-html="item.label"></span>
					</h4>
				</span>
				<b-form-group
					v-else-if="item.type === 'radio'"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
					style="margin-left: 25px"
				>
					<b-form-radio-group
						stacked
						v-model="item.data"
						v-on:input="radioTrig(key, item.ctrl, item.data)"
						:name="item.name"
						:options="item.init.options"
					></b-form-radio-group>

					<input
						hidden
						type="radio"
						:name="item.name"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name) }"
					/>

					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'select'"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-form-select
						v-model="item.data"
						:id="item.name"
						:name="item.name"
						:options="vfm_init(key)"
						v-validate="item.reqs"
						data-vv-validate-on="change"
						:class="{ 'is-danger': errors.has(item.name) }"
					></b-form-select>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'checkbox'"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-form-checkbox-group
						v-model="item.data"
						:id="item.id"
						size="sm"
						:name="item.name"
						:options="item.init.options"
						v-validate="item.reqs"
					></b-form-checkbox-group>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'textarea'"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
					style="margin-left: 25px"
				>
					<b-form-textarea
						v-model="item.data"
						:name="item.name"
						:placeholder="item.init.placeholder"
						:rows="5"
						:max-rows="10"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name) }"
					></b-form-textarea>
					<span v-if="item.reveal">
						<b-btn
							variant="link"
							size="sm"
							v-show="item.reveal && !items[item.reveal.target].show"
							v-on:click="clickReveal(item)"
							>{{ item.reveal.text }}</b-btn
						>
					</span>
					<span v-if="item.hide && item.reveal">
						<b-btn
							variant="link"
							size="sm"
							v-show="item.hide && !items[item.reveal.target].show"
							v-on:click="clickHide(item)"
							>{{ item.hide.text }}</b-btn
						>
					</span>
					<span v-if="item.hide && typeof item.reveal === 'undefined'">
						<b-btn
							variant="link"
							size="sm"
							v-show="item.hide"
							v-on:click="clickHide(item)"
							>{{ item.hide.text }}</b-btn
						>
					</span>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'link'"
					v-show="item.show"
					:description="item.help"
				>
					<span v-html="item.label"></span>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'number' && !item.name.includes('Table Row')"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-input-group>
						<b-form-input
							type="number"
							step="0"
							min="0"
							:name="item.name"
							:id="item.name"
							v-model="item.data"
							:placeholder="vfm_init(key)"
							v-validate="item.reqs"
							:class="{ 'is-danger': errors.has(item.name) }"
							class="col-md-1"
						></b-form-input>
					</b-input-group>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'currency'"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-input-group prepend="$">
						<b-form-input
							type="number"
							step="0.01"
							min=".01"
							:name="item.name"
							:id="item.name"
							v-model="item.data"
							:placeholder="vfm_init(key)"
							v-validate="item.reqs"
							:class="{ 'is-danger': errors.has(item.name) }"
						></b-form-input>
					</b-input-group>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.name.includes('Phone')"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-form-input
						:type="item.type"
						:name="item.name"
						:id="item.name"
						v-model="item.data"
						v-bind:formatter="phoneFormatter"
						maxlength="10"
						:placeholder="vfm_init(key)"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name) }"
					></b-form-input>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<!-- table format on item start -->
				<b-form-group 
					v-else-if="item.name.includes('Table Row')"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
					style="padding: 5px 0; width: 100%; margin: 10px;"
				>
					<b-form-input
						type="number"
						step="0"
						min="0"
						col="2"
						:type="item.type"
						:name="item.name"
						v-model="item.data"
						:placeholder="vfm_init(key)"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name)}"
						style="float: right; text-align: center; width: 15%; margin-top: -2em; margin-right: 10px"
					></b-form-input>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
					
				</b-form-group>

				<b-form-group
					v-else
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
					style="margin-left: 25px"
				>
					<b-form-input
						:type="item.type"
						:name="item.name"
						:id="item.name"
						v-model="item.data"
						:placeholder="vfm_init(key)"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name) }"
					></b-form-input>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>
			</div>
			<b-jumbotron v-if="totEstimate > 0" style="text-align: left; margin-top: 3em;">
				<!-- <p>Your on-campus tuiton rate is <strong>{{ tuitionRateOn.toFixed(2) }}</strong> per credit hour.</p> -->
				<b-row>
					<b-col sm="12" style="font-size: 1.5em; margin-bottom: 1em; font-weight: 600;">Estimated Undergraduate Tuition and Fees</b-col>
				</b-row>
				<b-row style="border-bottom: #071d49 solid 1px; font-weight: 600;">
					<b-col sm="6">Tuition and Fees</b-col>
					<b-col sm="2" style="text-align: center;">Credits</b-col>
					<b-col sm="2" style="text-align: center;">Rate</b-col>
					<b-col sm="2" style="text-align: center;">Total</b-col>
				</b-row>
				<b-row v-if="this.onCampusTuition > 0">
					<b-col sm="6">On-Campus Tuition </b-col>
					<b-col sm="2" style="text-align: center;">{{ onCampusCredits }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ tuitionRateOn.toFixed(2) }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ onCampusTuition.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
				<b-row v-if="this.onlineTuition > 0">
					<b-col sm="6">Off-Campus Tuition </b-col>
					<b-col sm="2" style="text-align: center;">{{ this.items.vfm_online.data }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ this.onlineRate.toFixed(2) }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ onlineTuition.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
				<b-row>
					<b-col sm="12"></b-col>
				</b-row>
				<b-row v-if="this.onCampusCredits > 0">
					<b-col sm="6">General Activity Fee </b-col>
					<b-col sm="2" style="text-align: center;">{{ onCampusCredits }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ this.gaRate.toFixed(2) }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ activityFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
				<b-row v-if="this.aesFee > 0">
					<b-col sm="6">Atmospheric & Environmental Science Fee </b-col>
					<b-col sm="2" style="text-align: center;">{{ this.items.vfm_aes.data }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ this.aesRate.toFixed(2) }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ aesFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
				<b-row v-if="this.bioFee > 0">
					<b-col sm="6">Biology Fee </b-col>
					<b-col sm="2" style="text-align: center;">{{ this.items.vfm_bio.data }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ this.bioRate.toFixed(2) }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ bioFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
				<b-row v-if="this.chemFee > 0">
					<b-col sm="6">Chemistry Fee </b-col>
					<b-col sm="2" style="text-align: center;">{{ this.items.vfm_chem.data }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ this.chemRate.toFixed(2) }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ chemFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
				<b-row v-if="this.geoFee > 0">
					<b-col sm="6">Geology Fee </b-col>
					<b-col sm="2" style="text-align: center;">{{ this.items.vfm_geo.data }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ this.geoRate.toFixed(2) }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ geoFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
				<b-row v-if="this.phyFee > 0">
					<b-col sm="6">Physics Fee </b-col>
					<b-col sm="2" style="text-align: center;">{{ this.items.vfm_phy.data }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ this.phyRate.toFixed(2) }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ phyFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
				<b-row v-if="this.csiFee > 0">
					<b-col sm="6">Computer Science Fee </b-col>
					<b-col sm="2" style="text-align: center;">{{ this.items.vfm_csi.data }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ this.csiRate.toFixed(2) }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ csiFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
				<b-row v-if="this.engFee > 0">
					<b-col sm="6">Engineering Fee </b-col>
					<b-col sm="2" style="text-align: center;">{{ this.items.vfm_eng.data }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ this.engRate.toFixed(2) }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ engFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
				<b-row v-if="this.mathFee > 0">
					<b-col sm="6">Math Fee </b-col>
					<b-col sm="2" style="text-align: center;">{{ this.items.vfm_math.data }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ this.mathRate.toFixed(2) }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ mathFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
				<b-row v-if="this.musFee > 0">
					<b-col sm="6">Music Fee </b-col>
					<b-col sm="2" style="text-align: center;">{{ this.items.vfm_mus.data }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ this.musRate.toFixed(2) }}</b-col>
					<b-col sm="2" style="text-align: right;">{{ musFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
				<b-row style="border-top: #071d49 solid 1px">
					<b-col sm="6" style="font-weight: 600;">Estimate Total</b-col>
					<b-col sm="2" right></b-col>
					<b-col sm="2"></b-col>
					<b-col sm="2" style="text-align: right; font-weight: 600;">{{ totEstimate.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
				</b-row>
			</b-jumbotron>
			<!--<hr />-->

			<b-card
				show
				id="terms-gp"
				name="terms-gp"
				v-if="terms.show"
			>
				<h6 v-if="terms.title">{{ terms.title }}</h6>
				<p class="help-text" v-if="terms.text">{{ terms.text }}</p>
				<hr v-if="terms.text" />
				<b-form-checkbox
					id="terms-cb"
					name="terms-cb"
					v-model="terms.data"
					value="accepted"
					unchecked-value
					v-validate.initial="'required'"
					><p v-html="terms.label"></p>
				</b-form-checkbox>
			</b-card>

			<b-card
				show
				bg-variant="light"
				id="sendEmail"
				name="sendEmail"
				v-if="totEstimate > 0"
			>
				<h6 v-if="sendEmail.title">{{ sendEmail.title }}</h6>
				<p class="help-text" v-if="sendEmail.text">{{ sendEmail.text }}</p>
				<hr v-if="sendEmail.text" />
				<b-form-checkbox
					id="sendEmail-cb"
					name="sendEmail-cb"
					v-model="sendEmail.data"
					value="accepted"
					unchecked-value
					v-validate.initial="'required'"
					><p v-html="sendEmail.label" style="font-size: 1em;"></p>
				</b-form-checkbox>
				<b-form-group
					label="First Name"
					label-for="firstName"
					v-if="sendEmail.data == 'accepted'">
				<b-form-input
					id="firstName"
					v-model="firstName.data"
					placeholder="first name"
					type="text"
					v-validate.initial="'required'"
					>
				</b-form-input>
				</b-form-group>
				<b-form-group
					label="Last Name"
					label-for="lastName"
					v-if="sendEmail.data == 'accepted'">
				<b-form-input
					id="lastName"
					v-model="lastName.data"
					placeholder="last name"
					type="text"
					v-validate.initial="'required'"
					>
				</b-form-input>
				</b-form-group>
				<b-form-group
					label="Email Address"
					label-for="emailAddress"
					v-if="sendEmail.data == 'accepted'">
				<b-form-input
					id="emailAddress"
					v-model="emailAddress.data"
					placeholder="email address"
					type="text"
					v-validate.initial="'required|email'"
					>
				</b-form-input>
					
				</b-form-group>
			<!--<hr />-->
			<p><b-button :disabled="errors.any()" size="lg" type="submit" variant="dark" style="margin-top: 1em"
				v-if="sendEmail.data == 'accepted'">Submit</b-button
			></p>
			<!-- <b-button :disabled='true' size='lg' type='submit' variant='dark'>Submit</b-button> -->
			<p v-if="sendEmail.data == 'accepted'" v-show="errors.any()" style="font-size:.8rem; color: #999999; line-height: 3em">Button disabled. Name and email address fields are required.</p> 

		</b-card>
		<p> </p>
		<b-form-text>
		<p v-html="footer.desc" style="margin: 1.5em 0; font-size: 1.3em;"></p>
		</b-form-text>
		</form>

		<div id="debug" class="debug" v-show="meta.datadebug">
			<h2>Debug</h2>
			<div>
				Errors = {{ errors.any() }}
				<br />
				{{ errors.all() }}
			</div>
			<ul v-for="item in items">
				<span v-if="item.type !== 'nodata'">
					<li>
						<div>
							{{ item.name }}:
							<span class="data-debug">{{ item.data }}</span>
						</div>
						<div v-if="item.ctrl">{{ item.ctrl }}</div>
					</li>
				</span>
			</ul>
			<div v-for="csv in csvPath_a">{{ csv.path }}</div>
			<div>{{ results.confirm }}</div>
		</div>
		<div v-if="meta.templatedebug">
			<h3 style="margin-top: 2em">Confirm Template:</h3>
			<hr style="border-bottom: dashed 1px" />
		</div>
		<div id="confirm_template" v-show="meta.templatedebug">
			<p>Thanks for your interest in South Dakota Mines! Here's your estimated undergraduate tuition and fees.</p>
			<b-row>
				<b-col sm="12" style="font-size: 1.5em; margin-bottom: 1em; font-weight: 600;">Estimated Undergraduate Tuition and Fees</b-col>
			</b-row>
			<b-row style="border-bottom: #071d49 solid 1px; font-weight: 600;">
				<b-col sm="6">Tuition and Fees</b-col>
				<b-col sm="2" style="text-align: center;">Credits</b-col>
				<b-col sm="2" style="text-align: center;">Rate</b-col>
				<b-col sm="2" style="text-align: center;">Total</b-col>
			</b-row>
			<b-row v-if="this.onCampusTuition > 0">
				<b-col sm="6">On-Campus Tuition </b-col>
				<b-col sm="2" style="text-align: center;">{{ onCampusCredits }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ tuitionRateOn.toFixed(2) }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ onCampusTuition.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<b-row v-if="this.onlineTuition > 0">
				<b-col sm="6">Off-Campus Tuition </b-col>
				<b-col sm="2" style="text-align: center;">{{ this.items.vfm_online.data }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ this.onlineRate.toFixed(2) }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ onlineTuition.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<b-row>
				<b-col sm="12"></b-col>
			</b-row>
			<b-row v-if="this.onCampusCredits > 0">
				<b-col sm="6">General Activity Fee </b-col>
				<b-col sm="2" style="text-align: center;">{{ onCampusCredits }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ this.gaRate.toFixed(2) }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ activityFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<b-row v-if="this.aesFee > 0">
				<b-col sm="6">Atmospheric & Environmental Science Fee </b-col>
				<b-col sm="2" style="text-align: center;">{{ this.items.vfm_aes.data }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ this.aesRate.toFixed(2) }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ aesFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<b-row v-if="this.bioFee > 0">
				<b-col sm="6">Biology Fee </b-col>
				<b-col sm="2" style="text-align: center;">{{ this.items.vfm_bio.data }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ this.bioRate.toFixed(2) }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ bioFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<b-row v-if="this.chemFee > 0">
				<b-col sm="6">Chemistry Fee </b-col>
				<b-col sm="2" style="text-align: center;">{{ this.items.vfm_chem.data }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ this.chemRate.toFixed(2) }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ chemFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<b-row v-if="this.geoFee > 0">
				<b-col sm="6">Geology Fee </b-col>
				<b-col sm="2" style="text-align: center;">{{ this.items.vfm_geo.data }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ this.geoRate.toFixed(2) }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ geoFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<b-row v-if="this.phyFee > 0">
				<b-col sm="6">Physics Fee </b-col>
				<b-col sm="2" style="text-align: center;">{{ this.items.vfm_phy.data }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ this.phyRate.toFixed(2) }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ phyFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<b-row v-if="this.csiFee > 0">
				<b-col sm="6">Computer Science Fee </b-col>
				<b-col sm="2" style="text-align: center;">{{ this.items.vfm_csi.data }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ this.csiRate.toFixed(2) }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ csiFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<b-row v-if="this.engFee > 0">
				<b-col sm="6">Engineering Fee </b-col>
				<b-col sm="2" style="text-align: center;">{{ this.items.vfm_eng.data }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ this.engRate.toFixed(2) }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ engFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<b-row v-if="this.mathFee > 0">
				<b-col sm="6">Math Fee </b-col>
				<b-col sm="2" style="text-align: center;">{{ this.items.vfm_math.data }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ this.mathRate.toFixed(2) }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ mathFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<b-row v-if="this.musFee > 0">
				<b-col sm="6">Music Fee </b-col>
				<b-col sm="2" style="text-align: center;">{{ this.items.vfm_mus.data }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ this.musRate.toFixed(2) }}</b-col>
				<b-col sm="2" style="text-align: right;">{{ musFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<b-row style="border-top: #071d49 solid 1px">
				<b-col sm="6" style="font-weight: 600;">Estimate Total</b-col>
				<b-col sm="2" right></b-col>
				<b-col sm="2"></b-col>
				<b-col sm="2" style="text-align: right; font-weight: 600;">{{ totEstimate.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b-col>
			</b-row>
			<p style="margin-top: 2em">Want to learn more? Fill out this form: <a href="https://apply.sdsmt.edu/register/ug-info-request">https://apply.sdsmt.edu/register/ug-info-request</a>.</p>
			<p>If you have any questions, feel free to email us at <a href="mailto:admissions@sdsmt.edu">admissions@sdsmt.edu</a> — we're happy to help!</p>
		</div>

		<div v-if="meta.templatedebug">
			<h3 style="margin-top: 2em">Email Template 1:</h3>
			<h6>To: {{ results.emails[0].to }}</h6>
			<hr style="border-bottom: dashed 1px" />
		</div>
		<div id="email_template_1" v-show="meta.templatedebug">
			<div style>
				<p style="margin-top: 2em;">Name:  {{ firstName.data }} {{ lastName.data }}<br />
				Email: {{ emailAddress.data }}<br />
				State: {{ this.items.vfm_state.data }}, {{ this.items.vfm_tuitionCategory.data }}</p>
				<p>The student indicates an interest in the following subjects</p>
				<ul>
					<li v-if="this.items.vfm_online.data != ''">{{ this.items.vfm_online.label }}</li>
					<li v-if="this.items.vfm_aes.data != ''">{{ this.items.vfm_aes.label }}</li>
					<li v-if="this.items.vfm_bio.data != ''">{{ this.items.vfm_bio.label }}</li>
					<li v-if="this.items.vfm_chem.data != ''">{{ this.items.vfm_chem.label }}</li>
					<li v-if="this.items.vfm_geo.data != ''">{{ this.items.vfm_geo.label }}</li>
					<li v-if="this.items.vfm_phy.data != ''">{{ this.items.vfm_phy.label }}</li>
					<li v-if="this.items.vfm_csi.data != ''">{{ this.items.vfm_csi.label }}</li>
					<li v-if="this.items.vfm_eng.data != ''">{{ this.items.vfm_eng.label }}</li>
					<li v-if="this.items.vfm_math.data != ''">{{ this.items.vfm_math.label }}</li>
					<li v-if="this.items.vfm_mus.data != ''">{{ this.items.vfm_mus.label }}</li>
					<li v-if="this.items.vfm_other.data != ''">{{ this.items.vfm_other.label }}</li>
				</ul>

				<hr />
				<h4 style="text-align: left;">Estimated Undergraduate Tuition and Fees</h4>
				<ul>
				<table
					style="width:800px; border-collapse:collapse; background-color: #e9ecef;"
				>
					<tr style="border-bottom: #071d49 solid 1px; font-weight: 600; padding: 20px 10px 0 10px ;">
						<td sm="6">Tuition and Fees</td>
						<td sm="2" style="text-align: center;">Credits</td>
						<td sm="2" style="text-align: center;">Rate</td>
						<td sm="2" style="text-align: center;">Total</td>
					</tr>
					<tr style="padding: 0 10px;">
						<td colspan="4"><hr></td>
					</tr>
					<tr v-if="this.onCampusTuition > 0" style="padding: 0 10px;">
						<td sm="6">On-Campus Tuition </td>
						<td sm="2" style="text-align: center;">{{ onCampusCredits }}</td>
						<td sm="2" style="text-align: right;">{{ tuitionRateOn.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ onCampusTuition.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.onlineTuition > 0" style="padding: 0 10px;">
						<td sm="6">Off-Campus Tuition </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_online.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.onlineRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ onlineTuition.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.onCampusCredits > 0" style="padding: 0 10px;">
						<td sm="6">General Activity Fee </td>
						<td sm="2" style="text-align: center;">{{ onCampusCredits }}</td>
						<td sm="2" style="text-align: right;">{{ this.gaRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ activityFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.aesFee > 0" style="padding: 0 10px;">
						<td sm="6">Atmospheric & Environmental Science Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_aes.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.aesRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ aesFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.bioFee > 0" style="padding: 0 10px;">
						<td sm="6">Biology Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_bio.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.bioRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ bioFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.chemFee > 0" style="padding: 0 10px;">
						<td sm="6">Chemistry Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_chem.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.chemRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ chemFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.geoFee > 0" style="padding: 0 10px;">
						<td sm="6">Geology Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_geo.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.geoRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ geoFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.phyFee > 0" style="padding: 0 10px;">
						<td sm="6">Physics Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_phy.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.phyRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ phyFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.csiFee > 0" style="padding: 0 10px;">
						<td sm="6">Computer Science Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_csi.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.csiRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ csiFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.engFee > 0" style="padding: 0 10px;">
						<td sm="6">Engineering Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_eng.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.engRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ engFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.mathFee > 0" style="padding: 0 10px;">
						<td sm="6">Math Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_math.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.mathRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ mathFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.musFeeFee > 0" style="padding: 0 10px;">
						<td sm="6">Music Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_mus.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.musRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ musFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr>
						<td colspan="4" style="padding: 0 10px;"><hr></td>
					</tr>
					<tr style="border-top: #071d49 solid 1px; padding: 0 10px 20px 10px ">
						<td sm="6" style="font-weight: 600;">Estimate Total</td>
						<td sm="2" right></td>
						<td sm="2"></td>
						<td sm="2" style="text-align: right; font-weight: 600;">{{ totEstimate.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
				</table>
				</ul>
			</div>
		</div>

		<div v-if="meta.templatedebug">
			<h3 style="margin-top: 2em">Email Template 2:</h3>
			<h6>To: {{ results.emails[1].to }}</h6>
			<hr style="border-bottom: dashed 1px" />
		</div>
		
		<div id="email_template_2" v-show="meta.templatedebug">
			<div style="width: 1000px;">

				<p>Thanks for your interest in South Dakota Mines! Here's your estimated undergraduate tuition and fees.</p>
				
				<ul>
				<table
					style="width:800px; border-collapse:collapse; background-color: #e9ecef;"
				>
					<tr>
						<td sm="12" colspan="4" style="padding: 20px 10px 0 10px"><h4 style="text-align: left;">Estimated Undergraduate Tuition and Fees</h4></td>
					</tr>
					<tr style="border-bottom: #071d49 solid 1px; font-weight: 600; padding: 20px 10px 0 10px ;">
						<td sm="6">Tuition and Fees</td>
						<td sm="2" style="text-align: center;">Credits</td>
						<td sm="2" style="text-align: center;">Rate</td>
						<td sm="2" style="text-align: center;">Total</td>
					</tr>
					<tr style="padding: 0 10px;">
						<td colspan="4"><hr></td>
					</tr>
					<tr v-if="this.onCampusTuition > 0" style="padding: 0 10px;">
						<td sm="6">On-Campus Tuition </td>
						<td sm="2" style="text-align: center;">{{ onCampusCredits }}</td>
						<td sm="2" style="text-align: right;">{{ tuitionRateOn.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ onCampusTuition.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.onlineTuition > 0" style="padding: 0 10px;">
						<td sm="6">Off-Campus Tuition </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_online.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.onlineRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ onlineTuition.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.onCampusCredits > 0" style="padding: 0 10px;">
						<td sm="6">General Activity Fee </td>
						<td sm="2" style="text-align: center;">{{ onCampusCredits }}</td>
						<td sm="2" style="text-align: right;">{{ this.gaRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ activityFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.aesFee > 0" style="padding: 0 10px;">
						<td sm="6">Atmospheric & Environmental Science Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_aes.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.aesRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ aesFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.bioFee > 0" style="padding: 0 10px;">
						<td sm="6">Biology Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_bio.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.bioRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ bioFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.chemFee > 0" style="padding: 0 10px;">
						<td sm="6">Chemistry Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_chem.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.chemRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ chemFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.geoFee > 0" style="padding: 0 10px;">
						<td sm="6">Geology Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_geo.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.geoRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ geoFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.phyFee > 0" style="padding: 0 10px;">
						<td sm="6">Physics Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_phy.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.phyRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ phyFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.csiFee > 0" style="padding: 0 10px;">
						<td sm="6">Computer Science Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_csi.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.csiRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ csiFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.engFee > 0" style="padding: 0 10px;">
						<td sm="6">Engineering Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_eng.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.engRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ engFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.mathFee > 0" style="padding: 0 10px;">
						<td sm="6">Math Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_math.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.mathRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ mathFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr v-if="this.musFeeFee > 0" style="padding: 0 10px;">
						<td sm="6">Music Fee </td>
						<td sm="2" style="text-align: center;">{{ this.items.vfm_mus.data }}</td>
						<td sm="2" style="text-align: right;">{{ this.musRate.toFixed(2) }}</td>
						<td sm="2" style="text-align: right;">{{ musFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
					<tr>
						<td colspan="4" style="padding: 0 10px;"><hr></td>
					</tr>
					<tr style="border-top: #071d49 solid 1px; padding: 0 10px 20px 10px ">
						<td sm="6" style="font-weight: 600;">Estimate Total</td>
						<td sm="2" right></td>
						<td sm="2"></td>
						<td sm="2" style="text-align: right; font-weight: 600;">{{ totEstimate.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td>
					</tr>
				</table>
				</ul>
				<p>Want to learn more? Fill out this form: <a href="https://apply.sdsmt.edu/register/ug-info-request">https://apply.sdsmt.edu/register/ug-info-request</a>.</p>
				<p>If you have any questions, feel free to email us at <a href="mailto:admissions@sdsmt.edu">admissions@sdsmt.edu</a> — we're happy to help!</p>
			</div>
		</div>
	</div>
</template>

<script>
import {  dates, meta, intro, footer, results, path_hash, terms, items, sendEmail, firstName, lastName, emailAddress } from "vfm/form-specs";

var timestamp = require("time-stamp");

export default {
	name: "VueForm",
	computed: {
		csvPath_a: function() {
			var a = [];
			for (var i = 0; i < this.results.csv_files.length; i++) {
				a[i] = {
					path: this.csvPath(i),
					omit: this.results.csv_files[i].omit
				};
			}
			return a;
		},

		// dateError: function() {
		// 	let startIndex = this.items.vfm_startdate.data ? this.dates.indexOf(this.items.vfm_startdate.data) : 0;
		// 	let endIndex =   this.items.vfm_enddate.data ? this.dates.indexOf(this.items.vfm_enddate.data) : 0;
		// 	if (endIndex > 0) return (endIndex - startIndex) > 0 ? false : true
		// 	else return false
		// },

		toggleCredits: function() {
			if (this.items.vfm_state.data == null) {
				return this.items.vfm_stateSelected.data = 'No';
			}
			else {
				return this.items.vfm_stateSelected.data = 'Yes';
			}
		},

		tuitionCategory: function() {
			if (this.items.vfm_state.data == null) {
				return this.items.vfm_tuitionCategory.data = ''
			}
			else if (this.items.vfm_state.data == ('CO') || this.items.vfm_state.data == ('IL') || this.items.vfm_state.data == ('IA') || this.items.vfm_state.data == ('KS') || this.items.vfm_state.data == ('MN') || this.items.vfm_state.data == ('MO') || this.items.vfm_state.data == ('MT') || this.items.vfm_state.data == ('NE') || this.items.vfm_state.data == ('ND') || this.items.vfm_state.data == ('SD') || this.items.vfm_state.data == ('WI') || this.items.vfm_state.data == ('WY')) {
				return this.items.vfm_tuitionCategory.data = 'In State Rate'
			}
			else if (this.items.vfm_state.data == ('AK') || this.items.vfm_state.data == ('AZ') || this.items.vfm_state.data == ('CA') || this.items.vfm_state.data == ('HI') || this.items.vfm_state.data == ('ID') || this.items.vfm_state.data == ('NV') || this.items.vfm_state.data == ('NM') || this.items.vfm_state.data == ('OR') || this.items.vfm_state.data == ('UT') || this.items.vfm_state.data == ('WA')) {
				return this.items.vfm_tuitionCategory.data = 'WUE Rate'
			}
			else {
				return this.items.vfm_tuitionCategory.data = 'Out of State Rate'
			}
		},

		tuitionRateOn: function() {
			if (this.tuitionCategory == ('In State Rate') ) {
				return this.items.vfm_tuitionRateOn.data = 273.60
			}
			else if (this.tuitionCategory == ('WUE Rate')) {
				return this.items.vfm_tuitionRateOn.data = 410.35
			}
			else if (this.tuitionCategory == ('Out of State Rate')) {
				return this.items.vfm_tuitionRateOn.data = 428.45
			}
			else {
				return this.items.vfm_tuitionRateOn.data = 0.00
			}
		},

		onlineRate: function() {
			let online = 372.50
			return online 
		},

		gaRate: function() {
			let ga = 50.60
			return ga 
		},

		aesRate: function() {
			let aes = 86.35
			return aes 
		},

		bioRate: function() {
			let bio = 44.45
			return bio 
		},

		chemRate: function() {
			let chem = 89.05
			return chem 
		},

		geoRate: function() {
			let geo = 89.05
			return geo 
		},

		phyRate: function() {
			let phy = 89.05
			return phy 
		},

		csiRate: function() {
			let csi = 74.10
			return csi 
		},

		engRate: function() {
			let eng = 89.05
			return eng 
		},

		mathRate: function() {
			let math = 44.45
			return math 
		},

		musRate: function() {
			let mus = 16.70
			return mus 
		},

		onCampusCredits: function() {
			let campusCredits = Number(this.items.vfm_aes.data) + Number(this.items.vfm_bio.data) + Number(this.items.vfm_chem.data) + Number(this.items.vfm_geo.data) + Number(this.items.vfm_phy.data) + Number(this.items.vfm_csi.data) + Number(this.items.vfm_eng.data) + Number(this.items.vfm_math.data) + Number(this.items.vfm_mus.data) + Number(this.items.vfm_other.data)
			return campusCredits
		},

		onCampusTuition: function() {
			let campTuition = Number(this.onCampusCredits) * Number(this.tuitionRateOn)
			return campTuition
		},

		onlineTuition: function() {
			let onTuition = this.items.vfm_online.data * this.onlineRate
			return onTuition
		},

		activityFee: function() {
			let feeGA = this.onCampusCredits * this.gaRate
			return feeGA
		},

		aesFee: function() {
			let feeAES = this.items.vfm_aes.data * this.aesRate
			return feeAES
		},

		bioFee: function() {
			let feeBIO = this.items.vfm_bio.data * this.bioRate
			return feeBIO
		},

		chemFee: function() {
			let feeCHEM = this.items.vfm_chem.data * this.chemRate
			return feeCHEM
		},

		geoFee: function() {
			let feeGEO = this.items.vfm_geo.data * this.geoRate
			return feeGEO
		},

		phyFee: function() {
			let feePHY = this.items.vfm_phy.data * this.phyRate
			return feePHY
		},

		csiFee: function() {
			let feeCSI = this.items.vfm_csi.data * this.csiRate
			return feeCSI
		},

		engFee: function() {
			let feeENG = this.items.vfm_eng.data * this.engRate
			return feeENG
		},

		mathFee: function() {
			let feeMATH = this.items.vfm_math.data * this.mathRate
			return feeMATH
		},

		musFee: function() {
			let feeMUS = this.items.vfm_mus.data * this.musRate
			return feeMUS
		},

		totEstimate: function() {
			let estTotal = Number(this.onCampusTuition) + Number(this.onlineTuition) + Number(this.activityFee) + Number(this.aesFee) + Number(this.bioFee) + Number(this.chemFee) + Number(this.csiFee) + Number(this.engFee) + Number(this.geoFee) + Number(this.mathFee) + Number(this.phyFee) + Number(this.musFee)
			return estTotal
		},

		vfm_combined_name: function() {
			var s = "";
			for (var i = 0; i < this.hiddens.email_from_name.length; i++) {
				if (i !== 0) {
					s += " ";
				}
				if (
					typeof this.items[this.hiddens.email_from_name[i]] !== "undefined"
				) {
					s += this.items[this.hiddens.email_from_name[i]];
				} else s += this.hiddens.email_from_name[i];
			}
			return s;
		}

	},

	data() {
		return {
			meta: meta,
			results: results,
			items: items,
			intro: intro,
			footer: footer,
			path_hash: path_hash,
			terms: terms,
			sendEmail: sendEmail,
			firstName: firstName,
			lastName: lastName,
			emailAddress: emailAddress,
			email_1_body: "",
			email_2_body: "",
			confirm_template: "",
			csv_files: results.csv_files
		};
	},

	methods: {
		stampNow() {
			return timestamp("YYYY/MM/DD-HH:mm:ss");
		},

		onSubmit(evt) {
			evt.preventDefault();
			this.items.vfm_firstName.data = this.firstName.data
			this.items.vfm_lastName.data = this.lastName.data
			this.items.vfm_email.data = this.emailAddress.data
			this.email_1_body = document.getElementById("email_template_1").innerHTML;
			this.email_2_body = document.getElementById("email_template_2").innerHTML;
			this.confirm_template = document.getElementById(
				"confirm_template"
			).innerHTML;
			results.stamp = this.stampNow();
			this.$validator.validateAll().then(result => {
				if (result) {
					if (this.results.miners !== "") {
						results.action = "https://interact.sdsmt.edu/not-authorized.asp";
					} else {
						// update
						results.action =
							"https://sdmines.sdsmt.edu/cgi-bin/global/send_message_2.cgi";
					}
					this.$nextTick(() => {
						this.$refs.form.submit();
					});
				} else {
					alert("Oops. Please fill in the required fields.");
				}
			});
		},

		getCSVValue(omit, key) {
			if (omit.indexOf(key) === -1) {
				return items[key].name;
			} else return " - ";
		},

		vfm_init(key) {
			var item = items[key];
			switch (item.type) {
				case "select":
					if (item.data === "") {
						item.data = null;
					}
					var ph = item.init.placeholder
						? item.init.placeholder
						: "Choose an option";
					var top = [
						{
							text: ph,
							value: null
						}
					];

					if (typeof item.ctrl !== "undefined") {
						if (typeof item.ctrl.from !== "undefined") {
							var key = items[item.ctrl.from];
							var opts = item.init.options[key.data];
							if (typeof opts !== "undefined") {
								if (opts.indexOf(item.data) === -1) {
									item.data = null;
								}
								var opts_oa = [];
								for (var i = 0; i < opts.length; i++) {
									opts_oa[i] = {
										text: opts[i],
										value: opts[i]
									};
								}
								return top.concat(opts_oa);
							}

							top[0].text = item.ctrl.msg
								? item.ctrl.msg
								: "Options depend on another field...";
							return top;
						}
					}
					return top.concat(item.init.options);
				default:
					return item.init.placeholder
						? item.init.placeholder
						: ["Enter response here."];
			}
		},

		csvEnum(name, f_index, i_index) {
			return (
				"csv_" + (f_index + 1).toString() + "_field_" + (i_index + 1).toString()
			);
		},

		stampEnum(f_index) {
			var max = Object.keys(items).length;
			return (
				"csv_" + (f_index + 1).toString() + "_field_" + (max + 1).toString()
			);
		},

		csvPath(f_index) {
			var s = "/upload/results/";
			var ref = this.results.csv_files[f_index].file;
			var path = s + this.results.csv_files[f_index].path;
			// if there's a field with the same name as ref, use its data to build the filename
			if (typeof this.items[ref] !== "undefined") {
				var key = this.items[ref].data;
				if (key !== null && key !== "") {
					var code = this.path_hash[key];
					if (typeof code !== "undefined") {
						return path + key + "-" + code + ".csv";
					} else console.log("Code not found for hashed value.");
				}
				return path + key + ".csv";
			}
			//else csv_filed[i].file is just a filename string
			return path + ref;
		},

		radioTrig(key, ctrl, data) {
			var r = "";
			if (typeof ctrl !== "undefined") {
				for (var j = 0; j < ctrl.length; j++) {
					if (ctrl[j].opener.value === data) {
						for (var i = 0; i < ctrl[j].targets.length; i++) {
							this.items[ctrl[j].targets[i]].show = true;
							// r = this.items[ctrl[j].targets[i]].reqs;
							// // r += '|required';
							// r = "".concat("required|", r);
							// this.items[ctrl[j].targets[i]].reqs = r;
						}
					} else {
						for (var i = 0; i < ctrl[j].targets.length; i++) {
							this.items[ctrl[j].targets[i]].show = false;
							this.items[ctrl[j].targets[i]].data = "";
							r = this.items[ctrl[j].targets[i]].reqs;
							if (r.slice(0, 9) === "required|") {
								r = r.slice(9);
							}
							// if (r.slice(-9) === '|required') {
							//   r = r.slice(0, (r.length - 9));
							// }
							this.items[ctrl[j].targets[i]].reqs = r;
						}
					}
				}
			}
		}, // end radioTrig

		phoneFormatter(value){
			
			if(value.length == 10){
				var str1 = value.substr(0,3);
				var str2= value.substr(3,3);
				var str3 = value.substr(6,4);
				value = str1+"-"+str2+"-"+str3;
			}
			else if (value.length < 12){
				value = value.replaceAll("-","");
			}
			return value;
		} //end phoneFormatter

	} // end methods
	
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

hr{
	padding-top: 1.1em;
	border: 0;
}

ul {
	padding: 0;
}

li {
	margin: 0 0 .4em .1em;
}

div.is-danger {
	margin-top: 0.2rem;
	color: #b3a369;
	font-size: 0.8rem;
}

input.is-danger,
select.is-danger {
	border: solid #b3a369 1px;
}

.card-body p {
	font-size: 0.8rem;
}

.debug {
	font-size: 0.7em;
	max-width: 30%;
	height: 100%;
	overflow-y: scroll;
	position: fixed;
	border-right: solid 8px #b3a369;
	padding: 1em;
	right: 0;
	top: 0;
	background: rgba(7, 29, 73, 0.6);
	color: white;
	text-align: left;
}

.help-text {
	font-size: 0.8em;
	font-style: oblique;
	color: #666;
}

.data-debug {
	color: #999;
	font-style: oblique;
}

.jumbotron {
	/* background-color: #071d49;
  color: #fff;  */
	margin-bottom: 30px;
	font-size: 0.9rem;
	color: #071d49;
  	text-align: center;
	padding: 20px;
}

.miners {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/VueForm.vue